'use client';

import { c as _c } from "react/compiler-runtime";
import { use } from 'react';
import GenreHeader from '@/app/[locale]/(worlds)/(worlds-landing)/genre/[type]/components/GenreHeader';
import GenreSeoDescription from '@/app/[locale]/(worlds)/(worlds-landing)/genre/[type]/components/GenreSeoDescription';
import GenreWorlds from '@/app/[locale]/(worlds)/(worlds-landing)/genre/[type]/components/GenreWorlds';
import { useBIPageView } from '@/context/BISdkContext';
import type { GenreDetail as GenreDetailData } from '@/server/lib/genre';
import { getPublicRoomsV3 } from '@/services/cms';
type GenreDetailProps = {
  genre: string;
  genreDetailPromise: Promise<GenreDetailData>;
  genreWorldsPromise: ReturnType<typeof getPublicRoomsV3>;
};
export default function GenreDetail(t0) {
  const $ = _c(16);
  const {
    genre,
    genreDetailPromise,
    genreWorldsPromise
  } = t0;
  const genreDetail = use(genreDetailPromise);
  const genreWorldsData = use(genreWorldsPromise);
  let t1;
  if ($[0] !== genreWorldsData?.results?.results) {
    t1 = genreWorldsData?.results?.results || [];
    $[0] = genreWorldsData?.results?.results;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialWorlds = t1;
  const worldsCount = genreWorldsData?.results?.pages?.total || 0;
  useBIPageView();
  let t2;
  if ($[2] !== genreDetail.description || $[3] !== genreDetail.title || $[4] !== worldsCount) {
    t2 = <GenreHeader genreDescription={genreDetail.description} genreTitle={genreDetail.title} worldsCount={worldsCount} />;
    $[2] = genreDetail.description;
    $[3] = genreDetail.title;
    $[4] = worldsCount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== genre || $[7] !== initialWorlds || $[8] !== worldsCount) {
    t3 = <GenreWorlds initialWorlds={initialWorlds} worldsCount={worldsCount} genre={genre} />;
    $[6] = genre;
    $[7] = initialWorlds;
    $[8] = worldsCount;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== genreDetail.seoDescription) {
    t4 = genreDetail.seoDescription ? <GenreSeoDescription seoDescription={genreDetail.seoDescription} /> : null;
    $[10] = genreDetail.seoDescription;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}